import { fadeIn } from "react-animations";
import styled, { keyframes } from "styled-components";
import { Field } from "styles/formStyles";

export const Wrapper = styled.div`
  animation: 0.6s ${keyframes`${fadeIn}`};
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;

  ${(props) => props.theme.xs`
    justify-content: space-between;
  `}
`;

export const SearchGroup = styled.div`
  flex: 1;
  min-width: 160px;
  position: relative;

  input {
    width: 100%;
    padding-right: 36px;
  }
`;

export const SearchInputStyled = styled.input`
  ${Field};
`;

export { SearchButton } from "components/SearchInput/SearchInput.styles";
